<template>
  <GridContainer class="outdoor-product text--center">
    <GridRow>
      <GridColumn>
        <CdnImage
          v-if="localImage"
          :src="localImage"
          :alt="productName"
          render-without-figure
          class="outdoor-product__img"
          :style="`aspect-ratio: ${imageAspectRatio}`"
          lazy
        />
        <GoliathImageElement
          v-else
          class="outdoor-product__img"
          :image="offer.teaserImage"
          :alt="productName"
          xs-width="small"
          :render-without-figure="true"
          lazy
        />
      </GridColumn>
    </GridRow>
    <GridRow>
      <GridColumn class="outdoor-product__name">
        <Paragraph :text="productName" />
      </GridColumn>
    </GridRow>
    <GridRow>
      <GridColumn>
        <PricesContainer
          class="outdoor-product__price"
          :prices-data="offer.prices || []"
          :variant="'small'"
        />
      </GridColumn>
    </GridRow>
    <GridRow>
      <GridColumn class="outdoor-product__buttons">
        <AddToCartButtonContainer
          :display-text="true"
          :display-icon="false"
          :offer="offer"
        />
        <LinkButton
          transparent
          :tag="'nuxt-link'"
          :to="`/geraete/${offer.product.slug}`"
        >
          Mehr Details
        </LinkButton>
      </GridColumn>
    </GridRow>
  </GridContainer>
</template>

<script setup lang="ts">
import AddToCartButtonContainer from '@/components/product-detail/add-to-cart-button-container.vue';
import PricesContainer from '@/components/product-detail/prices-container.vue';
import {
  Paragraph,
  LinkButton,
  GoliathImageElement,
  GridContainer,
  GridRow,
  GridColumn,
} from '@i22-td-smarthome/component-library';
import CdnImage from '@/components/cdn-image.vue';
import { computed } from 'vue';

const props = defineProps({
  offer: { type: Object, default: () => {} },
  localImage: { type: String, default: '' },
  customHeading: { type: String, default: '' },
  imageAspectRatio: { type: String, default: '' },
});

const productName = computed(() => props.customHeading || props.offer.product.name);
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.outdoor-product {
  margin: 0 auto;
  height: 100%;
  padding-block: 3 * $grid-base;

  @include mq($mq-sm) {
    max-width: 500px;
  }

  @include mq($mq-md) {
    padding: 0 0 3 * $grid-base;
  }
  :deep(.prices) {
    padding-bottom: $grid-base;
  }
  &__name {
    @include font-size(24px, 29px);
    font-weight: 700;
  }
  &__img {
    height: 188px;
    width: auto;
    margin-bottom: 2 * $grid-base;
    aspect-ratio: 1;
    display: inline-block;

    @include mq($mq-sm) {
      height: 385px;
    }
    @include mq($mq-md) {
      margin-top: 3 * $grid-base;
    }
  }
  &__buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  :deep(.price__amount) {
    @include font-size(24px, 24px);
    font-weight: 800;
  }
}
</style>
